
import { DeskData } from '@/datamodel/deskdata'
import { GameResult } from '@/datamodel/game-result'
import { PopAlertModel, RoadMapSummaryData } from '@/datamodel/types'
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { RoadMapData } from '../roadmap/data-model'
import RoadMapView from '@/components/roadmap/index.vue'
import DPredictionSumaryView from '@/components/desk/prediction/d-prediction-sumary-view.vue'
import MultiBetView from '@/components/multi-view/multi-bet-view.vue'
import MultiCardResult from '@/components/multi-view/multi-card-result.vue'
import { Action, Getter } from 'vuex-class'
import MultiPrediction from './multi-prediction.vue'
import { useI18n } from 'vue-i18n'
import router, { ROUTES } from '@/router'
import { ResultMemberList, SocketMessage, Table } from 'vue'
import { EventBuss, RESULT, SOCKET_MESSAGE } from '@/utils/constants'
import { UserMutation } from '@/store/module/user'
import { store } from '@/store'

@Options({
    components: {
        RoadMapView,
        DPredictionSumaryView,
        MultiBetView,
        MultiCardResult,
        MultiPrediction
    }
})
export default class MultiViewSideListItem extends Vue {
    iN = useI18n().t
    @Prop({ default: -1 })
    index!: number

    @Prop({ default: undefined })
    deskData!: Table

    @Prop({ default: -1 })
    chipAmount!: number

    @Prop()
    isSuper6Mode!: boolean

    roadmapData!: RoadMapData

    @Prop({ default: false }) isDragActive!: boolean

    @Getter('memberId') memberId!: number

    isCurrentlyOnDraw = false

    nextRedRoadMapSummaryData: RoadMapSummaryData = {}
    nextBlueRoadMapSummaryData: RoadMapSummaryData = {}
    nextRed!: RoadMapData
    nextBlue!: RoadMapData

    predictionTimer: number | boolean = false
    predictionType = 0
    predictionCount = 9
    predictionBlink = 9

    deskTimer: number | boolean = false
    currentGameId: string | undefined
    showResult = false
    currentGameResult: GameResult | undefined

    deskResult = ''
    $emit!: Vue['$emit']
    $refs!: Vue['$refs']
    emitter!: Vue['emitter']

    beforeMount(): void {
        this.emitter.on(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
    }

    beforeUnmount(): void {
        if (typeof this.predictionTimer === 'number') {
            clearInterval(this.predictionTimer)
            this.predictionTimer = false
        }

        this.emitter.off(EventBuss.SOCKET_MESSAGE, this.handlesSocketMessages)
    }

    handlesSocketMessages(_message: SocketMessage | any) {
        const { type, gameTable } = _message
        const _type = (type as string).toUpperCase()

        if (_type === SOCKET_MESSAGE.END_GAME) {
            const sDesk = gameTable as Table
            // decide show result
            // check if same table
            if (this.deskData.id === sDesk.id) {
                const memberResultList = sDesk.expand
                    .winOrLoseList as ResultMemberList[]
                this.currentGameResult = new GameResult(sDesk)

                if (memberResultList && memberResultList.length > 0) {
                    const _memberResultInfo = memberResultList.find(
                        x => x.memberId === this.memberId
                    )

                    if (_memberResultInfo) {
                        // console.log('WIN OR LOST', _memberResultInfo)

                        store.commit(
                            UserMutation.SET_BET_COIN,
                            _memberResultInfo.amount
                        )

                        if (_memberResultInfo.winResult !== 0) {
                            let _amtStr = '0'

                            if (_memberResultInfo.winResult > 0)
                                _amtStr = `+${_memberResultInfo.winResult}`
                            else _amtStr = String(_memberResultInfo.winResult)
                            // console.log(_amtStr, 'WIN')

                            // emitter.emit(EventBuss.SMA, _amtStr)
                            // winOrLostAmount.value = parseInt(_amtStr)

                            const popError: PopAlertModel = {
                                type: 1,
                                header: '',
                                message: _amtStr,
                                color: ''
                            }
                            const winner = this.currentGameResult.whoWin

                            if (this.gameType === 'G002') {
                                if (
                                    winner === RESULT.RED ||
                                    winner === RESULT.SUPER6
                                ) {
                                    popError.header = '庄赢'
                                    popError.color = 'banker'
                                } else if (winner === RESULT.GREEN) {
                                    popError.header = '和局'
                                    popError.color = 'tie'
                                } else {
                                    popError.header = '闲赢'
                                    popError.color = 'player'
                                }
                            } else {
                                if (winner === RESULT.DRAGON) {
                                    popError.header = '龙赢'
                                    popError.color = 'banker'
                                } else if (
                                    winner === RESULT.DRAGON_TIGER_TIE ||
                                    winner === RESULT.GREEN
                                ) {
                                    popError.header = '和局'
                                    popError.color = 'tie'
                                } else {
                                    popError.header = '虎赢'
                                    popError.color = 'player'
                                }
                            }
                            this.emitter.emit(
                                EventBuss.SHOW_POP_ALERT,
                                popError
                            )
                        }
                    }
                }

                this.showResult = true
                setTimeout(() => {
                    this.showResult = false
                    this.currentGameResult = undefined
                }, 4000)
            }
        }
    }

    OnRoadMapData(
        data: RoadMapData,
        nextBlue: RoadMapData,
        nextRed: RoadMapData
    ): void {
        this.nextRedRoadMapSummaryData = { data: nextRed }
        this.nextBlueRoadMapSummaryData = { data: nextBlue }
    }

    handleOnPredict(value: number): void {
        const roadMapView = this.$refs['roadmapview'] as RoadMapView
        roadMapView.Predict(value)
    }

    resetBetView(): void {
        const betview = this.$refs['betview'] as MultiBetView
        if (betview) betview.resetBet()
    }

    OnClickVideo(): void {
        this.$emit('switch-focus-desk', this.deskData.id)
    }

    enterTable(): void {
        router.push({
            name: ROUTES.GAME,
            query: {
                desk: this.deskData.id,
                gameType: this.deskData.gameTypeNo
            }
        })
    }

    get allowBet(): boolean {
        return this.deskData.expand.daoJiShiBetTime > 0
    }

    get shoe() {
        if (this.deskData) return this.deskData.expand.shoeNo
        return ''
    }
    get juNo() {
        if (this.deskData) return this.deskData.expand.juNo
        return ''
    }

    get gameNo() {
        if (this.deskData) return this.deskData.expand.gameNo
        return ''
    }

    //#region Watcher
    @Watch('isDragActive')
    OnEnterDrag(value: boolean, oldValue: boolean): void {
        if (oldValue !== value) {
            const mapView = this.$refs['roadmapview'] as RoadMapView

            if (mapView) {
                mapView.isActive = value
                mapView.drapMap()
            }
        }
    }

    @Watch('deskData', { immediate: true })
    UpdateRoadMap(value: Table): void {
        if (value) {
            this.deskResult = value.expand.resultList.join('#') || ''
        }
    }
    //#endregion

    //#region  Computed Properties
    get gameType(): string {
        if (this.deskData) {
            return this.deskData.gameTypeNo
        }

        return ''
    }

    get title(): string {
        if (this.deskData.gameTypeNo === 'G002') {
            return `百家乐 ${this.deskData.id} 号桌`
        } else {
            return `龙虎 ${this.deskData.id} 号桌`
        }
    }

    get timerClass(): string {
        if (this.deskData.expand.daoJiShiBetTime > 20) {
            return 'green'
        } else if (
            this.deskData.expand.daoJiShiBetTime <= 20 &&
            this.deskData.expand.daoJiShiBetTime > 10
        ) {
            return 'orange'
        } else {
            return 'red'
        }
    }

    get currentTime(): string {
        if (this.deskData) {
            return this.deskData.expand.daoJiShiBetTime !== -1
                ? String(this.deskData.expand.daoJiShiBetTime)
                : ''
        }

        return ''
    }
    //#endregion
}
